import { render, staticRenderFns } from "./VuesticIconCleanCode.vue?vue&type=template&id=50f4dedc"
import script from "./VuesticIconCleanCode.vue?vue&type=script&lang=js"
export * from "./VuesticIconCleanCode.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconCleanCode.vue?vue&type=style&index=0&id=50f4dedc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports